import type { LayerKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { useCallback } from 'react'

export const useTranslateLayer = () => {
  const translate = useTranslate()
  return useCallback(
    (layer: Optional<LayerKey>) => {
      if (!layer?.layerId && layer?.tenantId) {
        return layer.tenantId
      }
      return `${layer?.tenantId ?? ''}${layer?.tenantId ? '/' : ''}${layer?.layerId ?? translate('layer.null')}`
    },
    [translate],
  )
}
